import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-vendor-ranking-dashboard',
  templateUrl: './vendor-ranking-dashboard.component.html',
  styleUrls: ['./vendor-ranking-dashboard.component.css'],
})
export class VendorRankingDashboardComponent implements OnInit {
  loading = true;
  orgRankings: any[] = [];
  invitations: any[] = [];
  invitationRankings: any[] = [];
  selectedInvitationId: number | null = null;
  selectedInvitationMeta: any = null;
  weights: any = null;
  projectFilter = '';

  scoreLabels: Record<string, string> = {
    price: 'Price',
    deviation: 'BOQ deviation',
    timeliness: 'Timeliness',
    history: 'Track record',
  };

  constructor(
    private api: ApiService,
    private toastr: ToastrMsgService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params['invitation_id']) {
        this.selectedInvitationId = +params['invitation_id'];
      }
      if (params['project_id']) {
        this.projectFilter = params['project_id'];
      }
      this.load();
    });
  }

  load(): void {
    this.loading = true;
    const orgParams: any = {};
    if (this.projectFilter) orgParams.project_id = this.projectFilter;

    this.api.getVendorRankingDashboard(orgParams).subscribe({
      next: (res: any) => {
        this.orgRankings = res?.data?.rankings || [];
        this.weights = res?.data?.weights;
        this.loadInvitations();
      },
      error: (err) => {
        this.loading = false;
        this.toastr.error(err?.error?.error || 'Failed to load vendor rankings');
      },
    });
  }

  loadInvitations(): void {
    const params: any = {};
    if (this.projectFilter) params.project_id = this.projectFilter;

    this.api.getVendorRankingInvitations(params).subscribe({
      next: (res: any) => {
        this.invitations = res?.data || [];
        if (this.selectedInvitationId) {
          this.loadInvitationRanking(this.selectedInvitationId);
        } else {
          this.loading = false;
        }
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  onInvitationChange(invitationId: number | null): void {
    this.selectedInvitationId = invitationId;
    if (invitationId) {
      void this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { invitation_id: invitationId, project_id: this.projectFilter || null },
        queryParamsHandling: 'merge',
      });
      this.loadInvitationRanking(invitationId);
    } else {
      this.invitationRankings = [];
      this.selectedInvitationMeta = null;
    }
  }

  loadInvitationRanking(invitationId: number): void {
    this.loading = true;
    this.api.getVendorRankingByInvitation(invitationId).subscribe({
      next: (res: any) => {
        const data = res?.data;
        this.invitationRankings = data?.rankings || [];
        this.selectedInvitationMeta = data?.invitation;
        this.weights = data?.weights || this.weights;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.toastr.error(err?.error?.error || 'Failed to load invitation ranking');
      },
    });
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount || 0);
  }

  scoreBarClass(score: number): string {
    if (score >= 75) return 'bg-emerald-500';
    if (score >= 50) return 'bg-amber-500';
    return 'bg-red-400';
  }

  viewBids(invitationId: number): void {
    void this.router.navigate(['/home/boq-bidding/view-bids', invitationId]);
  }

  scoreKeys(scores: any): string[] {
    return scores ? Object.keys(scores) : [];
  }
}
